import { Component, OnInit } from "@angular/core";
import { DataService_RoleAdminSU } from "../shared/data.service";
import { ConfirmationService } from "primeng/api";
import { SuRoleChangeUsersRequest } from "../shared/SuRoleChangeUsersRequest";
import { RoleSuSchoolOrDistrictComponent } from "../shared/role-su-school-or-district/role-su-school-or-district.component";
import { DialogService } from "primeng/dynamicdialog";
import { RoleSuRoleAddUsersComponent } from "../shared/role-su-role-add-users/role-su-role-add-users.component";

@Component({
	selector: "caass-role-su-school-maintenance",
	templateUrl: "./role-su-school-maintenance.component.html",
	styleUrls: ["./role-su-school-maintenance.component.css"],
})
export class RoleSuSchoolMaintenanceComponent implements OnInit {
	constructor(private dataService: DataService_RoleAdminSU, private confirmationService: ConfirmationService, private dialogService: DialogService) {}

	ngOnInit(): void {
		this.loadSchool();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	schoolpagerows: any = 5;
	schoolpagefirst: any = 0;

	userpagerows: any = 5;
	userpagefirst: any = 0;

	SelectedSchool: any;
	lstSchool: any = [];

	lstRoleNames: any = [];

	SchoolCols: any = [
		{ field: "SchoolName", header: "Name" },
		{ field: "SchoolNumber", header: "Number" },
	];

	ShowCAASS: boolean = true;
	ShowVPP: boolean = false;
	ShowMulti: boolean = false;
	ShowTransit: boolean = false;

	SelectedRole: any;

	SelectedUsers: any = [];
	lstUsers: any = [];

	lstPersonTypeDesc: any = [];
	lstUserLevelDesc: any = [];
	lstActiveDesc: any = [];

	UserCols: any = [
		{ field: "UserName", header: "Username" },
		{ field: "StaffID", header: "Staff ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "PersonTypeDesc", header: "Staff Type" },
		// { field: "SchoolFullName", header: "Home School" },
		// { field: "UserLevelDesc", header: "User Level" },
		// { field: "ActiveDesc", header: "Active" },
	];

	LoadingSchool: boolean = false;
	LoadingUser: boolean = false;
	Processing: boolean = false;

	errorMessage: string = "";

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSchool() {
		this.LoadingSchool = true;

		var result = this.dataService.RoleAdminSuSchoolRoleCountSelect();
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				for (var z = 0; z < this.lstSchool.length; z++) {
					var next = this.lstSchool[z];

					for (var r = 0; r < next.lstRoles.length; r++) {
						var nextRole = next.lstRoles[r];

						next[nextRole.RoleName] = nextRole.UserCount;
					}
				}

				this.UpdateSelectedRoles();

				this.LoadingSchool = false;
			},
			(error) => {
				this.LoadingSchool = false;
			}
		);
	}

	UpdateSelectedRoles() {
		for (var z = 0; z < this.lstSchool.length; z++) {
			var nextSchool = this.lstSchool[z];

			nextSchool.lstSelectedRoles = nextSchool.lstRoles.filter(
				(role) =>
					(role.RoleTypeID == 1 && this.ShowCAASS == true) ||
					(role.RoleTypeID == 2 && this.ShowVPP == true) ||
					(role.RoleTypeID == 3 && this.ShowMulti == true) ||
					(role.RoleTypeID == 4 && this.ShowTransit == true)
			);
		}

		this.lstRoleNames = [];
		if (this.lstSchool.length > 0) {
			this.lstRoleNames = this.lstSchool[0].lstRoles.filter(
				(role) =>
					(role.RoleTypeID == 1 && this.ShowCAASS == true) ||
					(role.RoleTypeID == 2 && this.ShowVPP == true) ||
					(role.RoleTypeID == 3 && this.ShowMulti == true) ||
					(role.RoleTypeID == 4 && this.ShowTransit == true)
			);
		}

		if (this.lstRoleNames.length > 0) {
			if (this.SelectedRole == undefined) {
				this.SelectedRole = this.lstRoleNames[0];
			} else {
				var found = false;
				for (var z = 0; z < this.lstRoleNames.length; z++) {
					var next = this.lstRoleNames[z];

					if (this.SelectedRole.RoleID == next.RoleID) {
						found = true;
						break;
					}
				}

				if (found == false) {
					this.SelectedRole = this.lstRoleNames[0];
				}
			}
		}
	}

	loadUser(UpdateSchools: boolean = false) {
		this.errorMessage = "";

		if (UpdateSchools == true) {
			this.UpdateSchoolCounts();
		}

		this.lstUsers = [];
		this.SelectedUsers = [];
		this.LoadingUser = true;

		var result = this.dataService.RoleAdminSuSelectUserByRole(this.SelectedSchool.SchoolID, this.SelectedRole.RoleID);
		result.subscribe(
			(response) => {
				this.lstUsers = response;

				//Load Data Filter Lists
				this.lstPersonTypeDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.PersonTypeDesc)));
				this.lstUserLevelDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.UserLevelDesc)));
				this.lstActiveDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.ActiveDesc)));

				this.LoadingUser = false;
			},
			(error) => {
				this.LoadingUser = false;
			}
		);
	}

	UpdateSchoolCounts() {
		this.LoadingSchool = true;

		var result = this.dataService.RoleAdminSuSchoolRoleCountSelect();
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				for (var z = 0; z < this.lstSchool.length; z++) {
					var next = this.lstSchool[z];

					for (var r = 0; r < next.lstRoles.length; r++) {
						var nextRole = next.lstRoles[r];

						next[nextRole.RoleName] = nextRole.UserCount;
					}

					next.lstSelectedRoles = next.lstRoles.filter(
						(role) =>
							(role.RoleTypeID == 1 && this.ShowCAASS == true) ||
							(role.RoleTypeID == 2 && this.ShowVPP == true) ||
							(role.RoleTypeID == 3 && this.ShowMulti == true) ||
							(role.RoleTypeID == 4 && this.ShowTransit == true)
					);
				}

				this.LoadingSchool = false;
			},
			(error) => {
				this.LoadingSchool = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onSchoolRefresh() {
		this.loadSchool();
	}

	onUserRefresh() {
		this.loadUser();
	}

	onAddUsers() {
		var popup_Width = (window.innerWidth - 80).toString() + "px";

		var ref = this.dialogService.open(RoleSuRoleAddUsersComponent, {
			header: "Add Users",
			width: popup_Width,
			data: {
				//INSERT Custom Data here
				School: this.SelectedSchool,
				Role: this.SelectedRole,
			},
		});
		ref.onClose.subscribe((response: number) => {
			if (response == -1 || response > 0) {
				this.loadUser(true);
			}
		});
	}

	onRemoveUsers() {
		if (this.SelectedUsers.length == 0) {
			this.errorMessage = "Select Users to remove from role";
			return;
		}

		//
		// Confirm Remove Role?
		//
		var Msg =
			"You are about to remove the " +
			this.SelectedRole.RoleDesc +
			" from " +
			this.SelectedUsers.length +
			" user" +
			(this.SelectedUsers.length == 1 ? "" : "s") +
			". This might remove the user from the user groups they are in. Are you sure you want to continue?";

		this.confirmationService.confirm({
			key: "schoolmaintconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Remove Roles",
			icon: "fa",
			accept: () => {
				this.onCheckRemoveSchool();
			},
		});
	}

	onCheckRemoveSchool() {
		//
		// School or District ?
		//

		var ref = this.dialogService.open(RoleSuSchoolOrDistrictComponent, {
			header: "School or District",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				School: this.SelectedSchool,
				UserCount: this.SelectedUsers.length,
				RoleDesc: this.SelectedRole.RoleDesc,
			},
		});
		ref.onClose.subscribe((response: number) => {
			if (response == -1 || response > 0) {
				this.onFinishRemoveUsers(response);
			}
		});
	}

	onFinishRemoveUsers(DistrictOption: number) {
		var lstUIDs: number[] = [];

		lstUIDs = this.SelectedUsers.map((user) => user.UserID);

		var parms: SuRoleChangeUsersRequest = {
			SchoolID: DistrictOption,
			RoleID: this.SelectedRole.RoleID,
			lstUserIDs: lstUIDs,
		};

		var result = this.dataService.SuRoleRemoveUsers(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "schoolmaintstatus",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "User Roles were removed successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadUser(true);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "schoolmaintstatus",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Remove User Roles: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onExportSchools() {
		var DataStr: string = "";

		//
		// Add Headers
		//

		DataStr += `"School Name",`;
		DataStr += `"School Number",`;

		for (var z = 0; z < this.lstSchool[0].lstRoles.length; z++) {
			var next = this.lstSchool[0].lstRoles[z];

			DataStr += `"` + next.RoleDesc + `"`;

			if (z < this.lstSchool[0].lstRoles.length - 1) {
				DataStr += `,`;
			}
		}

		DataStr += "\n";

		//
		// Add Data
		//
		for (var z = 0; z < this.lstSchool.length; z++) {
			var next = this.lstSchool[z];

			DataStr += `"` + next.SchoolName + `",`;
			DataStr += `"` + next.SchoolNumber + `",`;

			for (var x = 0; x < next.lstRoles.length; x++) {
				var nextRole = next.lstRoles[x];

				DataStr += `"` + nextRole.UserCount + `"`;

				if (x < next.lstRoles.length - 1) {
					DataStr += `,`;
				}
			}

			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "SchoolRoleSummary";

		//
		// Sometimes has issue with plain text, so convert to B64
		//
		DataStr = btoa(DataStr);
		a.href = "data:text/csv;base64," + DataStr;
		a.download = FileName + ".csv";

		a.click(); //Downloaded file
	}

	onExportRole() {
		var DataStr: string = "";

		//
		// Add Headers
		//

		DataStr += `"Username",`;
		DataStr += `"Staff ID",`;
		DataStr += `"First Name",`;
		DataStr += `"Last Name",`;
		DataStr += `"Staff Type",`;
		DataStr += `"Home School",`;
		DataStr += `"User Level",`;
		DataStr += `"Active",`;
		DataStr += "\n";

		//
		// Add Data
		//
		for (var z = 0; z < this.lstUsers.length; z++) {
			var next = this.lstUsers[z];

			DataStr += `"` + next.UserName + `",`;
			DataStr += `"` + next.StaffID + `",`;
			DataStr += `"` + next.FirstName + `",`;
			DataStr += `"` + next.LastName + `",`;
			DataStr += `"` + next.PersonTypeDesc + `",`;
			DataStr += `"` + next.SchoolFullName + `",`;
			DataStr += `"` + next.UserLevelDesc + `",`;
			DataStr += `"` + next.ActiveDesc + `",`;
			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var fSchool = this.ReplaceAllOccur(this.SelectedSchool.SchoolName, " ", "_");
		fSchool = this.ReplaceAllOccur(fSchool, "/", "");
		fSchool = this.ReplaceAllOccur(fSchool, "\\", "");

		var fRole = this.ReplaceAllOccur(this.SelectedRole.RoleDesc, " ", "_");
		fRole = this.ReplaceAllOccur(fRole, "/", "");
		fRole = this.ReplaceAllOccur(fRole, "\\", "");

		var FileName = "UserBySchoolRole_" + fSchool + "_" + fRole;

		//
		// Sometimes has issue with plain text, so convert to B64
		//
		DataStr = btoa(DataStr);
		a.href = "data:text/csv;base64," + DataStr;
		a.download = FileName + ".csv";

		a.click(); //Downloaded file
	}

	ReplaceAllOccur(source: string, searchFor: string, replaceWith: string): string {
		let ans: string = source;

		while (ans.indexOf(searchFor) != -1) {
			ans = ans.replace(searchFor, replaceWith);
		}

		return ans;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onSchoolRowSelect(val) {
		this.SelectedSchool = val.data;

		if (this.SelectedRole == undefined) {
			this.SelectedRole = this.lstRoleNames[0];
		} else {
			var found = false;
			for (var z = 0; z < this.lstRoleNames.length; z++) {
				var next = this.lstRoleNames[z];

				if (this.SelectedRole.RoleID == next.RoleID) {
					found = true;
					break;
				}
			}

			if (found == false) {
				this.SelectedRole = this.lstRoleNames[0];
			}
		}

		this.loadUser();
	}

	onSchoolRowUnselect(val) {
		this.SelectedSchool = null;

		this.SelectedRole = null;
		this.lstUsers = [];
		this.SelectedUsers = [];
	}

	onUserRowSelect(val) {
		this.errorMessage = "";
	}

	onUserRowUnselect(val) {
		this.errorMessage = "";
	}

	onShowCAASSChange(val) {
		this.ShowCAASS = val;
		this.UpdateSelectedRoles();
	}

	onShowVPPChange(val) {
		this.ShowVPP = val;
		this.UpdateSelectedRoles();
	}

	onShowMultiChange(val) {
		this.ShowMulti = val;
		this.UpdateSelectedRoles();
	}

	onShowTransitChange(val) {
		this.ShowTransit = val;
		this.UpdateSelectedRoles();
	}

	onSelectedRoleChange(val) {
		this.SelectedRole = val;

		this.loadUser();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.LoadingSchool == true || this.LoadingUser == true || this.Processing == true;
	}

	////////////////////////////////////////////
}
